import { apiClient } from "./client";
import type { SlotKind } from "./types";

export type KindHours = Record<SlotKind, number>;

export type OrgWorkload = {
  organization_id: string;
  code: string;
  name: string;
  fte_percent: number;
  hours_by_kind: KindHours;
  total_hours: number;
  fte_quota_hours: number;
  over_fte: boolean;
};

export type PractitionerWorkload = {
  practitioner_id: string;
  display_name: string;
  from_date: string;
  to_date: string;
  weeks: number;
  by_org: OrgWorkload[];
  total_hours: number;
  total_by_kind: KindHours;
  avg_weekly_hours: number;
  has_garde: boolean;
  avg_over_48h: boolean;
  peak_over_60h: boolean;
  understaffed_hours: number;
  understaffed_pct: number;
};

export type WorkloadSummary = {
  practitioner_id: string;
  display_name: string;
  total_hours: number;
  avg_weekly_hours: number;
  by_kind: KindHours;
  has_garde: boolean;
  avg_over_48h: boolean;
  peak_over_60h: boolean;
  org_count: number;
};

export type TenantWorkload = {
  from_date: string;
  to_date: string;
  weeks: number;
  items: WorkloadSummary[];
};

export async function getPractitionerWorkload(
  practitionerId: string,
  from?: string,
  to?: string,
): Promise<PractitionerWorkload> {
  const { data } = await apiClient.get<PractitionerWorkload>(
    `/api/v1/workload/practitioners/${practitionerId}`,
    { params: { from, to } },
  );
  return data;
}

export async function getTenantWorkload(
  from?: string,
  to?: string,
  organizationId?: string,
): Promise<TenantWorkload> {
  const { data } = await apiClient.get<TenantWorkload>("/api/v1/workload", {
    params: { from, to, organization_id: organizationId },
  });
  return data;
}
